import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from "@ngrx/data";
import {PaymentRequestMovementRepository} from "./impl/service/ngrx/paymentRequestMovement.repository";
import {PaymentRequestMovementDataService} from "./impl/service/ngrx/paymentRequestMovementData.service";
import {PaymentRequestMovementDataServiceAdapter} from "./impl/service/ngrx/paymentRequestMovementDataService.adapter";

@NgModule({
    providers: [
        PaymentRequestMovementRepository,
        PaymentRequestMovementDataService,
        PaymentRequestMovementDataServiceAdapter,
    ],
})
export class PaymentRequestMovementModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: PaymentRequestMovementRepository,
                dataService: PaymentRequestMovementDataService,
    ) {

        entityDataService.registerServices({
            'PaymentRequestMovement': dataService,
        });

        entityServices.registerEntityCollectionServices({
            'PaymentRequestMovement': repository,
        });

        //  errorMessages.set('PRODUCT_SAVE_CODE_ALREADY_USED', 'Un produit avec ce code existe déjà');
    }
}
